export default class MainNav {

    constructor($view) {
        this.$view = $view;

        this.togglesNav = document.querySelectorAll('.js-toggle-nav')
        this.headerBottomContainer = document.querySelector('.js-header-bottom .container')
        this.visualLoaded = false;
        this.bind();
    }

    bind() {

        document.addEventListener('close-main-nav', e => {
            if ($(this).hasClass('opened')) {
                this.openCloseNav();
            }
        })

        // Bind toggles
        this.togglesNav.forEach(toggleNav => {
            toggleNav.addEventListener('click', e => {
                e.preventDefault()
                this.openCloseNav()
            })
        })

        // Update position
        setTimeout(() => {
            this.updatePosition();
        }, 500);
        window.addEventListener('resize', e => {
            this.updatePosition()
        })
        document.addEventListener('scroll', e => {
            this.updatePosition()
        })

        // Close nav on click outside panels
        this.$view.on('click', (e) => {
            if ($(e.target).is('.main-nav.opened') || $(e.target).hasClass('main-nav-inner')) {
                this.openCloseNav();
            }
        })

        // Toggle child panel
        const navLinksWithChildren = this.$view.find('a.has-children')

        navLinksWithChildren.on('click', (e) => {
            e.preventDefault();

            // On gère les états actif des liens
            const activeLinks = $(e.target).closest('.nav-panel').find('.active')
            activeLinks.removeClass('active')


            // On ferme tous les panels potentiellement ouverts ...
            const openedPanels = $(e.target).closest('.nav-panel').find('.nav-panel.opened')
            openedPanels.removeClass('opened')

            // ... et on ouvre le planel cible
            $(e.target).addClass('active')
            $(e.target).siblings().addClass('opened')
        })

        // Close panel
        const togglesPanel = this.$view.find('.js-toggle-panel')
        togglesPanel.on('click', (e) => {
            e.preventDefault()

            $(e.target).closest('.nav-panel').removeClass('opened')
        })

    }

    updatePosition() {
        if (this.headerBottomContainer) {
            const rect = this.headerBottomContainer.getBoundingClientRect()
            this.$view.css('--pos-top', rect.bottom.toString() + "px")
            this.$view.css('--pos-left', (rect.left + 16).toString() + "px")
            this.$view.css('--pos-width', rect.width.toString() + "px")
            console.log(this.$view);
            console.log(rect.width.toString() + "px");
        }

        // Autoconfigure nav max height for desktop
        // Get first level height
        const firstLvl = document.querySelector('.nav-panel-lvl-1 > .nav-panel-body > ul');
        const firstLvlHeight = firstLvl.getBoundingClientRect().height + 48;
        this.$view.css('--pos-height', firstLvlHeight.toString() + "px")

    }

    openCloseNav() {
        this.$view.toggleClass('opened')

        // On ferme tous les panels potentiellement ouverts ...
        const openedPanels = this.$view.find('.nav-panel.opened')
        openedPanels.removeClass('opened')

        // On supprime les états actifs des liens
        const activeLinks = this.$view.find('.active')
        activeLinks.removeClass('active')

        // On ajoute/retire la classe opened de tous les toggle
        this.togglesNav.forEach(toggleNav => {
            toggleNav.classList.toggle('opened');
        });

        if(this.visualLoaded == false)
        {
            this.$view.find('img').each(function() {
                $(this).attr("src",$(this).data("src"));
            });
            this.visualLoaded = true;
        }
    }

}


// WEBPACK FOOTER //
// ./public/frontend/js/components/MainNav.js